/**
 * Render the final JSX of TeachingPopoverTrigger
 */ export const renderTeachingPopoverTrigger_unstable = (state)=>{
    return state.children;
};
